import { reduxSwitch } from 'core/redux/tools';
import { ActionGeneratorBuilder } from 'core/redux/actions';

export const actions = new ActionGeneratorBuilder('zoneGuardsOccupancy')
	.type('addZoneGuardOccupancy', { id: true, occupancy: true })
	.type('addZoneGuardMustering', { id: true, mustering: true })
	.build();

const defaultState = {
	occupancies: {
		map: null,
	},
	mustering: {
		map: null,
	},
};

const loadReducer = (state, action) => {
	switch (action.type) {
		case actions.addZoneGuardOccupancy.type: {
			return {
				...state,
				occupancies: { ...state.occupancies, map: { ...state.map, [action.id]: action.occupancy } },
			};
		}
		case actions.addZoneGuardMustering.type: {
			return {
				...state,
				mustering: { ...state.mustering, map: { ...state.map, [action.id]: action.mustering } },
			};
		}
		default:
			return state;
	}
};

export const reducer = reduxSwitch([loadReducer], defaultState);
